<script setup lang="ts">
// Kairo in the sidebar: a way to the assistant (shown while the `kairo`
// flag is on for the account).
import avatarUrl from "@/assets/kairo/kairo-avatar.webp";

defineProps<{ collapsed?: boolean }>();
</script>

<template>
	<RouterLink
		v-if="!collapsed"
		to="/kairo"
		class="flex items-center gap-2.5 mx-3 mb-2 p-2.5 rounded-xl border border-line bg-panel hover:border-line-strong transition-colors"
		data-testid="sidebar-kairo"
	>
		<img :src="avatarUrl" alt="" class="size-8 rounded-full shrink-0 object-cover object-bottom bg-well" />
		<span class="flex-1 min-w-0">
			<span class="block text-[13px] font-medium truncate">Kairo</span>
			<span class="block text-[11px] text-fg-3 truncate">AI Printing Assistant</span>
		</span>
	</RouterLink>
	<RouterLink
		v-else
		to="/kairo"
		class="mx-auto mb-2 size-8 flex items-center justify-center rounded-lg hover:bg-card-hover transition-colors"
		aria-label="Kairo, AI Printing Assistant"
		v-tooltip.right="'Kairo'"
	>
		<img :src="avatarUrl" alt="" class="size-7 rounded-full object-cover object-bottom" />
	</RouterLink>
</template>
